/**
 * Converts given number to a specific locale string
 * @param n The number to convert
 * @param locale The destination locale e.g. 'de-DE'
 * @param floatPrecision Floating-Point Precision - default to 2
 */
export const formatNumber = (n: number, locale: 'de-DE' | 'en-GB', floatPrecision = 2) =>
  new Intl.NumberFormat(locale, { maximumFractionDigits: floatPrecision }).format(n);
